<div class="padding bg-light-grey">
	<div class="flex center">
		<span class="flex center primary hover margin-right" (click)="onBack()" style="cursor: pointer;">
			<i class="fa-solid fa-arrow-left margin-right-small"></i>
			Back
		</span>

		Orders
		<i class="fa-solid fa-angle-right padding-right-small padding-left-small grey"></i>
		{{ isCreateMode ? 'New order' : 'Order info' }}
	</div>
</div>

<!-- Button section -->
<div class="selector-container">
	@for(tab of tabs; track tab){
	<div class="tab-selector" [ngClass]="{'active': tab.url === activeSubRoute}" (click)="selectTab(tab.url)">
		{{tab.title}}
	</div>
	}
</div>

<div class="padding page-layout">
	<router-outlet (activate)="onOutletActivate($event)"/>
</div>
